import React from 'react';
import PropTypes from 'prop-types';

/**
 * What is actually narrowing the list, spelled out above it.
 *
 * The filter card is a row of inputs that look empty at a glance, and several
 * of these pages hide their rarer filters behind "More filters" — so a list
 * narrowed to one facility, or to one week, reads as "there is nothing here".
 * It is worse after arriving from a link somebody sent, where the filters were
 * never typed at all.
 *
 * Each chip removes its own filter, because the thing you want after noticing a
 * filter is usually to drop it.
 */

export default function ActiveFilters({ fields, query, onChange }) {
  // Paging is not filtering: "filtered by page 2" would be noise, and dropping
  // `resultsPerPage` from the chips keeps the row about the result set.
  const active = fields
    .filter(({ name }) => name !== 'page' && name !== 'resultsPerPage')
    .filter(({ name }) => query[name] !== undefined && query[name] !== '')
    .map(({ name, label, format }) => ({
      name,
      label,
      value: format ? format(query[name]) : query[name]
    }));

  if (active.length === 0) return null;

  const without = name => {
    const next = { ...query };
    delete next[name];
    return next;
  };

  return (
    <div className="next-chips">
      <span className="next-chips__label">Filtered by</span>

      {active.map(({ name, label, value }) => (
        <button
          type="button"
          className="next-chip"
          key={name}
          title={`Remove the ${label.toLowerCase()} filter`}
          onClick={() => onChange(without(name))}
        >
          <span className="next-chip__label">{label}</span>
          <span className="next-chip__value">{value}</span>
          <span className="next-chip__x" aria-hidden>×</span>
        </button>
      ))}

      {active.length > 1 && (
        <button type="button" className="next-chip next-chip--clear" onClick={() => onChange({})}>
          Clear all
        </button>
      )}
    </div>
  );
}

ActiveFilters.propTypes = {
  // `[{ name, label, format? }]` — the page's own filter definitions.
  fields: PropTypes.array.isRequired,
  query: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
